import { isBrowser } from './browserHelper';
import { isBokaTestServiceURL, BOKA_QUERY_PARAMS } from './urlHelper';

const { featureFlags } = CSS_CONFIG;
type FeatureType = keyof Omit<
  typeof featureFlags,
  'bokaTestService' | 'urlOverridable'
>;

const getUrlOverriddenFeatures = (): Set<string> => {
  if (!isBrowser()) return new Set();

  const queryParams = new URLSearchParams(window.location.search);
  const param = queryParams.get(BOKA_QUERY_PARAMS.ENABLE_BOKA_FEATURE);

  if (!param) return new Set();

  return new Set(param.split(',').map((f) => f.trim().toLowerCase()));
};

export const isFeatureEnabled = (feature: FeatureType): boolean => {
  const urlOverrides = getUrlOverriddenFeatures();
  if (
    urlOverrides.has(feature.toLowerCase()) &&
    featureFlags.urlOverridable?.[feature] === true
  ) {
    return true;
  }

  if (isBokaTestServiceURL()) {
    return !!featureFlags.bokaTestService?.[feature];
  }
  return featureFlags[feature];
};
